import getConfig from 'next/config';

const { NEXT_PUBLIC_SALES_APP_URL } = getConfig().publicRuntimeConfig;

export const businessFormRedirectHandler = (data) => {
  const queryParams = new URLSearchParams({
    number_of_employee: data.number_of_employees,
    phone_number: data.phoneNumber,
    email: data.email,
    company_name: data.company,
    name: data.company
  });
  
  window.location.href = `${NEXT_PUBLIC_SALES_APP_URL}/register?${queryParams.toString()}`;
};
